import { render, staticRenderFns } from "./workOrderDetails.vue?vue&type=template&id=0f2136e0&scoped=true&"
import script from "./workOrderDetails.vue?vue&type=script&lang=js&"
export * from "./workOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./workOrderDetails.vue?vue&type=style&index=0&id=0f2136e0&scoped=true&lang=css&"
import style1 from "./workOrderDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2136e0",
  null
  
)

export default component.exports